import svg4everybody from 'svg4everybody';
import './utils/imageHandler';
import * as preventUpload from './modules/tempPreventUpload';
import onReady from './utils/onReady';
import bootstrapper from './utils/bootstrapper';
import Megamenu from './modules/megamenu';
import Minibasket from './modules/minibasket';
import Basket from './modules/basket';
import AddToBasket from './modules/addToBasket';
import ImageSlider from './modules/imageSlider';
import BoxCollapse from './modules/boxCollapse';
import DatePicker from './modules/datePicker';
import RangeSlider from './modules/rangeSlider';
//import MobileNavigation from './modules/mobilenavigation';
import MobileMenu from './modules/mobilemenu.js';
import Filter from './modules/filter';
import FormValidate from './modules/formValidate';
import SearchSuggestions from './modules/search-suggestions';
import MapsGoogle from './modules/mapsGoogle';
import MapsMenu from './modules/mapsMenu';
import MyWaitingList from './modules/mywaitinglist';
import RemoveElement from './modules/removeElement';
import Gallery from './modules/gallery';
import VideoPlayer from './modules/videoPlayer';
import AppartmentComplex from './modules/apartment-complex';
import FileuploadDialog from './modules/fileuploaddlg';
import SubmitLoader from './modules/submitLoader';
import Breadcrumbs from './modules/breadcrumbs';
import Accordion from './modules/accordion';
import SectionInfo from './modules/sectionInfo';
import GlobalSearch from './modules/globalSearch';
import CourseSignUp from './modules/courseSignUp';
import ScrollingTables from './modules/scrollingtables';
import Payment from './modules/payment';
import ImageUploadDialog from './modules/imageuploaddlg';


// Bootstrap the modules. You can add as many modules as you want, as indicated by the commented lines.
// Please do not make multiple calls to bootstrapper()! One call with all the references will be MUCH faster.
// For more information, and alternate bootstrapping methods, look inside bootstrapper.js and check out the
// various exported methods.
bootstrapper({
    'megamenu': Megamenu,
    'minibasket': Minibasket,
    'basket': Basket,
    'addToBasket': AddToBasket,
    'imageSlider': ImageSlider,
    'boxCollapse': BoxCollapse,
    'datePicker': DatePicker,
    'rangeSlider': RangeSlider,
    //'sitenav': MobileNavigation,
    'mobilemenu': MobileMenu,
    'filter': Filter,
    'formValidate': FormValidate,
    'searchSuggestions': SearchSuggestions,
    'mapsGoogle': MapsGoogle,
    'mapsMenu': MapsMenu,
    'mywaitinglist': MyWaitingList,
    'removeElement': RemoveElement,
    'gallery': Gallery,
    'videoPlayer': VideoPlayer,
    'uploaddlg': FileuploadDialog,
    'apartmentcomplex': AppartmentComplex,
    'submitLoader': SubmitLoader,
    'breadcrumbs': Breadcrumbs,
    'accordion': Accordion,
    'sectionInfo': SectionInfo,
    'globalSearch': GlobalSearch,
    'courseSignUp': CourseSignUp,
    'payment': Payment,
    'imgUploaddlg': ImageUploadDialog,
});



// Run svg4everybody at low priority, giving our own modules time to instantiate first.
onReady(() => {
    svg4everybody();

    // Adding a div around tables. If the table is wider than the screen, scrolbars will be added.
    ScrollingTables.makeAllTablesScroll(document.querySelector("main.articlepage"));

    try {
        preventUpload.initPreventUpload("#edit-my-profile");
    } catch (error) {
        window.console.error(error);
    }

});



// Want to expose jQuery to the global scope for some reason? Okay then. Do this:
//
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;